import React from 'react';
import { Box, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';

/**
 * Uploaded by template with icon
 */
export const UploadedByTemplate: React.FC<{ uploadBy: string }> = ({ uploadBy }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
    <Person sx={{ fontSize: 14, color: '#64748b' }} />
    <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
      {uploadBy}
    </Typography>
  </Box>
);

export default UploadedByTemplate;
